import { makeStyles } from '@rentacenter/racstrap';

export const GlobalFacturaInputStyles = makeStyles({
  // Styling constants as CSS classes
  modalMarginBottom: {
    marginBottom: '20px',
  },
  marginBottom30px: {
    marginBottom: '30px',
  },
  padding12px: {
    padding: '12px',
  },
  whiteColor: {
    backgroundColor: '#fff',
  },
  fontSize16px: {
    fontSize: '16px',
  },
  marginBottom8px: {
    marginBottom: '8px',
  },
  whiteTextColor: {
    color: 'white',
  },
  buttonBackgroundColor: {
    backgroundColor: '#4285f4',
  },
  borderRadius5px: {
    borderRadius: '5px',
  },
  container: {
    padding: '16px',
    backgroundColor: '#f5f5f5',
  },
  headerGrid: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '24px',
  },
  title: {
    width: '200px',
    height: '30px',
    fontWeight: 700,
    fontFamily: 'Open Sans',
    fontSize: '22px',
    lineHeight: '100%',
    whiteSpace: 'nowrap',
  },
  filterButton: {
    backgroundColor: '#4285f4',
    color: 'white',
    textTransform: 'none',
    fontSize: '14px',
    padding: '8px 16px',
    borderRadius: '5px',
  },
  card: {
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    borderRadius: '15px',
  },
  formContainer: {
    gap: '15px',
  },
  fieldGrid: {
    borderRadius: '15px',
    marginLeft: '15px',
    maxWidth: '250px',
  },
  storeGrid: {
    maxWidth: '250px',
  },
  label: {
    width: '290px',
    height: '22px',
    fontWeight: 600,
    fontFamily: 'Open Sans',
    fontSize: '16px',
    lineHeight: '100%',
  },
  fieldWrapper: {
    marginTop: '5px',
  },
  storeWrapper: {
    marginTop: '5px',
    borderRadius: '25px',
  },
  buttonContainer: {
    marginTop: '35px',
  },
  buttonGrid: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '20px',
  },
  button: {
    borderRadius: '5px',
  },
  cellStyle: {
    padding: '12px',
    color: '#4A5174',
    fontWeight: 600,
    fontFamily: 'Open Sans',
  },
});
